import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function FullLoader() {
  return (
    <div className="grid min-h-screen place-items-center">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-ink/15 border-t-brand-500" />
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user || user.role !== 'admin') return <Navigate to="/login" replace />;
  return children;
}
